module.exports = __webpack_public_path__ + "img/icon_historial_morado.69564a93.svg";